import React, {useEffect, useState}					from 'react';
import {useNavigate, Link}							from 'react-router-dom';

import DeviceStatus									from './DeviceStatus';
import Icon											from '../Icon';
import Checkbox										from '../Checkbox';
import Badge										from '../Badge';
import Select										from '../Select';
import ModalAssign									from '../ModalAssign';
import DeviceImage									from './DeviceImage';

import {useAppSelector, useAppDispatch}				from '../../../app/hooks';
import {assignDevicesApi}							from '../../../redux/devices/devices';
import {Device}										from '../../../redux/devices/interface';
import {Catalog}									from '../../../redux/catalog/interface';
import {User}										from '../../../redux/user/interface';
import {Address}									from '../../../redux/address/interface';
import {InputValues}								from '../Input/interface';

import {ft_genNotification, ft_pushNotification}	from '../../functions/notification';
import {ft_search}									from '../../functions/search';
import {ft_getDeviceName, ft_getDevicePrice,
	ft_getDeviceStatus}								from '../../functions/deviceFunction';
import {ft_formatAddressInline, ft_formatPrice,
	ft_formatUserName}								from '../../functions/format';
import {ft_selectDataUser}							from '../../functions/selectData';

import img_arrowRight								from '../../images/icon/arrow/right.svg';
import img_deviceIcon								from '../../images/icon/devices/computer.svg';
import img_usersPlus								from '../../images/icon/users-plus.svg';
import img_chevron									from '../../images/icon/chevron-down.svg';

import LANGUAGE										from '../../language';

import './DeviceComponent.css';

type OptionsList = 'screenSize' | 'stockage' | 'processor' | 'state' | 'network' | 'graphicCard' | 'memory' | 'keyboard' | 'format' | 'dataVolume';

interface DeviceCardProps {
	device?: Device,
	shopData?: Catalog,
	link?: boolean,
	selected?: boolean,
	checkbox?: boolean | 'round',
	search?: InputValues,
	onClick?: () => void,
	forceUser?: boolean,
	previousSelected?: boolean,
	showPrice?: boolean | string,
	price?: number,
	assign?: string,
	oldCard?: boolean,
	onClickAssign?: (idUser?: User) => void,
	hideBadge?: boolean,
	addressSelect?: boolean,
	onClickAddress?: () => void,
	actualAddress?: Address
	hideAssign?: boolean,
	assignReadOnly?: boolean,
	duration?: number,
	disabled?: boolean,
	forceAssign?: boolean
	resetAssign?: boolean
}

function DeviceCard(props: DeviceCardProps): React.ReactElement {
	const dispatch = useAppDispatch();
	const users = useAppSelector(state => state.companyUsers.data);
	const user = useAppSelector(state => state.user.data);
	const contracts = useAppSelector(state => state.contracts.data);
	const lang = useAppSelector(state => state.settings.lang);
	const notificationId = useAppSelector(state => state.notifications.lastId);

	const [modal, set_modal] = useState(false);
	const [seeProperty, set_seeProperty] = useState('close');

	const [assignUser, set_assignUser] = useState<User>();
	const [load, set_load] = useState(false);

	const navigate = useNavigate();
	const TEXTE = LANGUAGE(lang);

	const deviceUser = (!props.link || props.forceUser) ? users.find(find => find && find._id === props.device?.user) : null;
	const fullName = ft_formatUserName(deviceUser);

	useEffect(() => set_seeProperty('close'), [props.device]);

	if (props.device && props.shopData)
		return <div />;

	if (props.search && props.device && !ft_search([props.device.name, ft_formatUserName(deviceUser), props.device.serial], props.search as string, true, true))
		return <div />;


	function assignDevice() {
		if (props.onClickAssign) {
			set_modal(false);
			return props.onClickAssign(assignUser);
		}
		if (!props.device)
			return;

		set_load(true);

		dispatch(assignDevicesApi({
			user,
			assignUser,
			devicesId:  [props.device._id]
		})).then(() => {
			const notificationData = ft_genNotification(TEXTE, 'assignDeviceSuccess', img_deviceIcon, ft_formatUserName(assignUser));
			ft_pushNotification(dispatch, notificationId, notificationData);

			set_load(false);
			set_modal(false);
		});
	}

	function renderPropertiyLine(name: OptionsList, value?: string) {
		if (!value && props.device?.shopData && name !== 'keyboard')
			value = props.device.shopData.info?.[name];
		if (!value && props.device?.notValalaData && name !== 'keyboard')
			value = props.device.notValalaData[name];
		if (!value && props.shopData && name !== 'keyboard')
			value = props.shopData.info?.[name];

		if (!value)
			return;
		return (
			<div>
				<span className={'text-xs gray-500 weight-700'}>{`${TEXTE.global[name]} : `}<span className={'weight-400'}>{value}</span></span>
			</div>
		);
	}

	function renderTags() {
		const render: React.ReactElement[] = [];

		props.device?.tags?.forEach((tag) => {
			render.push(
				<Badge
					color={'tags'}
					size={'sm'}
					text={tag}
				/>
			);
		});

		return <div>{render}</div>;
	}

	if (!props.oldCard) {
		const price = props.device ? ft_getDevicePrice(props.device, contracts) : props.price;
		let assign = '';

		if (props.device?.user)
			assign = typeof(props.device.user) === 'string' ? props.device.user : props.device.user._id;
		else if (props.assign)
			assign = props.assign;

		return (
			<div
				data-disabled={props.disabled}
				className={`deviceCard inline ${props.selected && 'selected'} ${(props.onClick || props.link) && 'onClick'}`}
				onClick={() => {
					if (props.onClick)
						props.onClick();
					if (props.link)
						navigate(`/devices/${props.device?._id}`);
				}}
			>
				<div>
					{props.checkbox &&
						<Checkbox
							active={props.selected}
							round={props.checkbox === 'round'}
							style={{alignSelf: 'center', marginRight: 12}}
						/>
					}

					<DeviceImage
						imageFormat={'small'}
						device={props.device}
						catalog={props.shopData}
						className={'deviceCardImg'}
					/>

					<div className={'deviceCardInfos'}>
						<div>
							<DeviceStatus device={props.device} />
							{(props.duration !== undefined && props.duration !== 36) &&
								<Badge
									size={'sm'}
									color={'primary'}
									text={`${props.duration} ${TEXTE.global.month}`}
								/>
							}
						</div>
						<span className={'text-sm weight-600 gray-900'}>
							{props.device ? ft_getDeviceName(props.device) : props.shopData?.name}
						</span>
					</div>

					{(!props.hideBadge && props.device) &&
						<Badge
							size={'sm'}
							color={props.device.notValala ? 'gray' : 'primary'}
							text={props.device.notValala ? TEXTE.global.notValala : TEXTE.global.valala}
						/>
					}

					{(!props.hideAssign && ft_getDeviceStatus(props.device, users) !== 'locationEnd') ?
						<>
							{props.addressSelect ?
								<div className={'flex flex-center'}>
									<Select
										value={1}
										onClick={props.onClickAddress}
										data={[{value: 1, render: ft_formatAddressInline(props.actualAddress)}]}
									/>
								</div>
								:
								<div className={'flex flex-center'}>
									{assign ?
										<Select
											value={assign}
											reset={props.resetAssign}
											readOnly={props.assignReadOnly}
											data={ft_selectDataUser(users)}
											onReset={() => {
												if (props.onClickAssign)
													props.onClickAssign(undefined);
											}}
											onClick={() => {
												set_modal(true);
												set_assignUser(users.find(find => find?._id === assign));
											}}
										/>
										:
										<>
											<Badge
												color={'gray'}
												img={img_usersPlus}
												text={TEXTE.global.affect}
												onClick={() => set_modal(true)}
											/>
											{props.forceAssign &&
												<Badge
													color={'error'}
													text={TEXTE.global.needeed}
												/>
											}
										</>
									}
								</div>
							}
						</>
						:
						<div className={'flex hideMobile'} />
					}

					{(props.showPrice && price !== undefined) &&
						<span className={'text-md gray-800 weight-600'}>
							{typeof props.showPrice === 'string' ?
								<span className={'text-sm gray-600 weight-600'}>{props.showPrice}</span>
								:
								<>
									{ft_formatPrice(price)}
									<span className={'text-sm gray-600 weight-600'}>{`/${TEXTE.global.month}`}</span>
								</>
							}
						</span>
					}

					<Icon
						icon={img_chevron}
						className={`anim-rotate-invert-${seeProperty}`}
						onClick={() => set_seeProperty(seeProperty === 'open' ? 'close' : 'open')}
					/>
				</div>

				{seeProperty === 'open' &&
					<div className={'deviceCardPropertyContainer'}>
						{renderPropertiyLine('state')}
						{renderPropertiyLine('screenSize')}
						{renderPropertiyLine('processor')}
						{renderPropertiyLine('memory')}
						{renderPropertiyLine('stockage')}
						{renderPropertiyLine('graphicCard')}
						{renderPropertiyLine('network')}
						{renderPropertiyLine('keyboard', props.device?.keyboard)}
						{renderPropertiyLine('format')}
						{renderPropertiyLine('dataVolume')}
						<div /><div /><div />
					</div>
				}

				{(props.device && seeProperty === 'open') &&
					<div className={'deviceCardTagsContainer'}>
						<span className={'text-xs weight-700 gray-500'}>{TEXTE.devices.deviceTags}</span>
						{renderTags()}
					</div>
				}

				{modal &&
					<ModalAssign
						modalRight
						load={load}
						onConfirm={assignDevice}
						onChange={set_assignUser}
						onClose={() => set_modal(false)}
						actualId={assignUser?._id ? [assignUser._id] : []}
					/>
				}
			</div>
		);
	}

	return (
		<div
			style={{
				marginTop:  (props.previousSelected && props.selected) ? -2 : undefined,
				paddingTop: (props.previousSelected && props.selected) ? 16 : undefined
			}}
			className={`deviceCard ${props.selected && 'selected'} ${props.onClick && 'onClick'}`}
			onClick={() => (props.onClick ? props.onClick() : undefined)}
		>
			{props.checkbox &&
				<Checkbox
					active={props.selected}
					round={props.checkbox === 'round'}
					style={{alignSelf: 'center'}}
				/>
			}

			<DeviceImage
				device={props.device}
				className={'deviceCardImg'}
			/>

			<div className={'deviceCardInfos'}>
				<DeviceStatus device={props.device} />
				<span className={'deviceCardName'}>{props.device ? ft_getDeviceName(props.device) : props.shopData?.name}</span>
				{fullName && <div className={'deviceCardUser'}>{fullName}</div>}
				{(props.link && props.device?.company === user?.company) &&
					<Link
						className={'deviceCardLink'}
						to={`/devices/${props.device?._id}`}
					>
						{TEXTE.component.device.seeDevice}
						<Icon icon={img_arrowRight} />
					</Link>
				}
			</div>
		</div>
	);
}

export default DeviceCard;
